import React, { Component } from 'react'
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import {loadImages, resetImages} from "../../../../../../api/images";
import TimePickerDialog from "material-ui/TimePicker/TimePickerDialog";
import DatePickerDialog from "material-ui/DatePicker/DatePickerDialog";
import Select from 'react-select';
import DateTimePicker from 'material-ui-datetimepicker';
import FileDropZoneDialog from '../../parts/FileDropZoneDialog';
import { getTopics, resetTopics } from "../../../../../../api/topics";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';



class PromotionGeneralTopicPartnerComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			options: [],
			minEndDate: Date.now(),
			users: []
		};

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
		this.selectImage = this.selectImage.bind(this);
		this.getTopicsList = this.getTopicsList.bind(this);
		this.handleTopicChange = this.handleTopicChange.bind(this);
	}

	componentWillMount() {
		// resetImages().then( () => {
		// 	loadImages( this.props.imageSizes.width, this.props.imageSizes.height );
		// });

		getTopics();
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handleState( name, value );
	}

	handleStartDateChange = ( dateTime ) => {
		const timeStamp = new Date( dateTime ).getTime();

		api.promotions.handleState( 'startDateTimeStamp', timeStamp );
	};

	handleEndDateChange = ( dateTime ) => {
		const timeStamp = new Date( dateTime ).getTime();

		api.promotions.handleState( 'endDateTimeStamp', timeStamp );
	};

	selectImage(image) {
		this.setState({
			...this.state,
			image: image
		});

		api.promotions.handleState( 'image', image );
	}

	getTopicsList() {
		const topicsList = this.props.topics.data.map( ( topic, index ) => {
			return (
				<MenuItem key={index} value={topic.key} primaryText={topic.name} />
			)
		});

		return topicsList;
	}

	handleTopicChange(event, index, value) {
		api.promotions.handleState( 'topicIds', value);
	}

	render() {
		return (
			<div className="grid-x grid-margin-y grid-margin-x">
				<div className="medium-6 cell">
					<label>
						Afbeelding
						<FileDropZoneDialog
							onDrop={this.processFiles}
							promotionType="topicPartner"
							selectImage={this.selectImage}
							width={190}
							height={130}
						/>
						{undefined !== this.props.promotion.image && this.props.promotion.image.thumbPath &&
						<img src={this.props.promotion.image.thumbPath} />
						}
					</label>
					<small>De afbeelding dient een exact formaat van 190x130 pixels te hebben.</small>
				</div>
				<div className="medium-6 cell">
					<label>
						Koppelen aan topics
						<SelectField
							fullWidth={true}
							value={this.props.promotion.topicIds}
							onChange={this.handleTopicChange}
							multiple={true}
						>
							{this.getTopicsList()}
						</SelectField>
					</label>
				</div>
				<div className="medium-12 cell">
					<div className="grid-x grid-margin-y grid-margin-x">
						<div className="medium-6 cell">
							<label>
								Startdatum
								<DateTimePicker
									onChange={this.handleStartDateChange}
									DatePicker={DatePickerDialog}
									TimePicker={TimePickerDialog}
									format='DD MMM YYYY HH:mm'
									timeFormat="24hr"
									fullWidth={true}
									value={new Date(this.props.promotion.startDateTimeStamp)}
									datePickerMode={'landscape'}
								/>
							</label>
						</div>
						<div className="medium-6 cell">
							<label>
								Einddatum
								<DateTimePicker
									onChange={this.handleEndDateChange}
									DatePicker={DatePickerDialog}
									TimePicker={TimePickerDialog}
									format='DD MMM YYYY HH:mm'
									timeFormat="24hr"
									fullWidth={true}
									value={undefined !== this.props.promotion.endDateTimeStamp && 0 !== this.props.promotion.endDateTimeStamp && this.props.promotion.endDateTimeStamp !== null ? new Date(this.props.promotion.endDateTimeStamp) : ''}
									minDate={this.state.minEndDate}
								/>
							</label>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion,
		topics: state.topics
	}
};

export default connect(mapStateToProps, {
	loadImages,
	resetImages,
	getTopics,
	resetTopics
})(PromotionGeneralTopicPartnerComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/general/topicPartner.js